import { HrRepresentative } from "@teamprevent/common/hrRepresentatives/models";

import { RecruitmentManager } from "../../../recruitmentManagers/models";
import { LineManager } from "../../../lineManagers/models";

import { OrgLevel, QuestionnaireData } from "../../model";

export interface ReferralFormState {
    lineManagers: LineManager[];
    recruitmentManagers: RecruitmentManager[];
    hrRepresentatives: HrRepresentative[];
    orgLevels: OrgLevel[];
}

export interface ReferralInProgress {
    id?: string;
    data: QuestionnaireData;
    eTag: string | null | undefined;
    isInitial?: boolean;
    referAgainOhCaseId?: string;
}

export const DATE_FORMAT = "LLLL";

export interface LoadReferralRequestModel {
    apiUrl: string;
    customerId?: string;
    questionnaireId?: string;
    ohCaseId?: string;
}
